import {UseAppointmentInfoProps} from './types';

import {DateFormatEnum} from 'presentation/constants';
import {TelemedicineEnum} from 'presentation/pages/private/booking/constants';

import {TypeAttendance} from 'presentation/modules/myAppointments/constants/typeAttendanceEnum';
import {useHistoryTheme} from 'presentation/modules/myAppointments/hooks/useHistoryTheme';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {formatDateWithWeekday, getAppointmentHistoryBookingType} from 'presentation/utils';
import IconNamesType from 'presentation/icons/IconNamesType';

export function useAppointmentInfo({appointmentDetails}: UseAppointmentInfoProps) {
	const {isTablet, isMobile, isLaptop} = useMediaQueries();
	const {clinic, provider, protocol, specialty, date, typeAttendance, appointmentIdPublic} =
		appointmentDetails;
	const bookingType = getAppointmentHistoryBookingType({
		telemedicine: clinic.telemedicine,
		typeAttendance,
	});

	const {
		day,
		month: monthName,
		formatted,
	} = formatDateWithWeekday(date, DateFormatEnum.DATE_FORMAT_9);

	const {iconName: historyIconName} = useHistoryTheme({historyFilter: bookingType});

	const isTelehealth = clinic.telemedicine === TelemedicineEnum.IS_TELEMEDICINE;
	const isSurgery = typeAttendance === TypeAttendance.SURGERY;
	const iconName = isTelehealth ? 'remember-me-filled' : ('location-on-filled' as IconNamesType);
	const templateColumns1Fr = (!isSurgery && (!protocol || isTablet)) || (isSurgery && isLaptop);

	return {
		isMobile,
		clinic,
		provider,
		protocol,
		specialty,
		date,
		typeAttendance,
		appointmentIdPublic,
		bookingType,
		day,
		monthName,
		formatted,
		historyIconName,
		isTelehealth,
		isSurgery,
		iconName,
		templateColumns1Fr,
	};
}
